export default __webpack_public_path__ + "static/media/Group9157.7f7432d3.svg";